import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { setBackButtonVisibility } from "../utils/CommonFunctions";
import UserService from "../services/UserService";

/**
 * Uses the current route to determine the name, content and theme to show for the route
 * @returns {name, content, theme}
 */
const usePageData = () => {
  const location = useLocation();
  const route = useMemo(() => location.pathname.replace(/^\/+/, "").replace(/\/+$/, ""), [location]);
  const [pageContent, updatePageContent] = useState<any>([]);
  const [theme, updateTheme] = useState<any>({});
  const [pageName, setPageName] = useState(route);

  // Safely extract the slug if a saved tenant exists
  const getSavedTenantSlug = (): string | null => {
    const savedTenant = UserService.getAttribute("savedLocationTenant");

    if (
      savedTenant &&
      typeof savedTenant === "object" &&
      !Array.isArray(savedTenant) &&
      "slug" in savedTenant &&
      typeof savedTenant.slug === "string"
    ) {
      return savedTenant.slug;
    }

    return null;
  };

  useEffect(() => {
    const savedSlug = getSavedTenantSlug();
    if (savedSlug) {
      setPageName(savedSlug);
    }

    const initialTenant = savedSlug || "homepage";
    if (initialTenant === route) {
      setBackButtonVisibility(false);
    }
  }, []);
  useEffect(() => {
    updateTheme(window.config.theme || {});
    const savedSlug = getSavedTenantSlug();
    if (window.config) {
      if (route && window.config.pages?.[route]) {
        setPageName(route); 
        updatePageContent(window.config.pages[route]);
      } else if (savedSlug && window.config.pages?.[savedSlug]) {
        setPageName(savedSlug); 
        updatePageContent(window.config.pages[savedSlug]);
      } else if (window.config.pages?.homepage) {
        setPageName("homepage");
        updatePageContent(window.config.pages.homepage);
      }
    }
  }, [route]);

  return { name: pageName, content: pageContent, theme };
};

export default usePageData;
